import React, { useState } from "react";
import { Phone, MessageCircle, Send, X } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

export function ContactNowModal({ open, onOpenChange, business }) {
  const [form, setForm] = useState({ name: "", mobile: "", message: "" });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.mobile) {
      toast.error("Please enter your name and mobile number");
      return;
    }
    setLoading(true);
    try {
      await api.post("/enquiries", { business_id: business.id, ...form });
      setSent(true);
      toast.success("Request sent! The business will contact you soon.");
    } catch (e) {
      toast.error("Could not send request. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const close = () => {
    onOpenChange(false);
    setTimeout(() => { setSent(false); setForm({ name: "", mobile: "", message: "" }); }, 200);
  };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="sm:max-w-md rounded-2xl" data-testid="contact-now-modal">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">Contact {business?.name}</DialogTitle>
        </DialogHeader>
        {sent ? (
          <div className="text-center py-6">
            <div className="w-14 h-14 rounded-full bg-green-100 text-green-600 flex items-center justify-center mx-auto mb-4">
              <Send className="w-6 h-6" />
            </div>
            <p className="font-semibold">Aapki request bhej di gayi hai!</p>
            <p className="text-sm text-muted-foreground mt-1">The business owner will reach out to you shortly.</p>
            <Button className="mt-5 rounded-full" onClick={close} data-testid="contact-done-btn">Done</Button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <Input placeholder="Your Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="rounded-xl h-12" data-testid="contact-name-input" />
            <Input placeholder="Mobile Number" value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} className="rounded-xl h-12" data-testid="contact-mobile-input" />
            <Textarea placeholder="Message / Requirement" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="rounded-xl" rows={3} data-testid="contact-message-input" />
            <Button type="submit" disabled={loading} className="w-full rounded-full h-12 font-semibold gap-2" data-testid="contact-send-btn">
              <Send className="w-4 h-4" /> {loading ? "Sending…" : "Send Request"}
            </Button>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
